<script setup lang="ts">
/**
 * The default Grove site layout, with optionality on notification bar, header,
 * footer and background color display.
 *
 * NOTE:
 * Eventually we may deprecate optionality in favor of one consistent layout
 * for all Grove (e.g. full header with search bar, cart).
 * Decision to deprecate is pending a design and performance review, as the
 * simplified layout may have important site speed benefits.
 */

const {
  meta: {
    showFullFooter = true,
    linenBackground = false,
    containsFlushContent = false,
  },
} = useRoute()

const layoutClasses = computed(() => ({
  LayoutDefault: true,
  'LayoutDefault--WithRowGap': !containsFlushContent,
}))

const contentClasses = computed(() => ({
  LayoutDefault_Content: true,
  'LayoutDefault_Content--LinenBackground': linenBackground,
  'LayoutDefault_Content--Contain': !containsFlushContent,
}))
</script>

<template>
  <div :class="layoutClasses">
    <TheHeader data-test-id="header" />

    <main data-test-id="content" :class="contentClasses">
      <slot />
    </main>

    <TheFooter data-test-id="footer" :hide-sections="!showFullFooter" />
  </div>
</template>

<style lang="scss">
.LayoutDefault--WithRowGap {
  row-gap: var(--spacing-6x);
}

.LayoutDefault {
  display: grid;
  grid-template-rows: auto 1fr auto;
  min-height: 100vh;

  &_Content--Contain {
    @include container-small;
    max-width: 100vw;
    display: grid;
    grid-template-rows: auto 1fr auto;
    row-gap: var(--spacing-6x);
    margin-top: var(--spacing-6x);

    @include for-medium-up {
      --container-max: #{$container-medium};
    }

    @include for-large-up {
      --container-max: #{$container-large};
    }

    .SkyLink {
      /**
      * Some pages can contain very long links.
      * They should break to prevent horizontal scrolling.
      */
      word-wrap: break-word;
    }
  }

  &_Content--LinenBackground {
    background-color: var(--surface-color-linen);
  }
}
</style>
